export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';
import './index.styl'; 

import {bind, Table, TableColumn} from 'kpc';
import {range} from 'kpc/components/utils';

interface Props {
    allData: DataItem[]
    leftData: DataItem[]
    rightData: DataItem[]
    leftCheckedKeys: number[]
    rightCheckedKeys: number[]
    leftKeywords: string
    rightKeywords: string
    leftFilteredData: DataItem[]
    rightFilteredData: DataItem[]
}

type DataItem = {
    id: number
    name: string
    ip: string
    status: string
}

const rawData = range(1, 50).map(item => ({
    id: item,
    name: `服务器${item}`,
    ip: `10.10.1.${item}`,
    status: item % 3 === 0 ? '运行中' : item % 3 === 1 ? '已停止' : '维护中'
}));

export default class extends Component<Props> {
    static template = template;

    static defaults() {
        return {
            allData: rawData,
            leftData: rawData,
            rightData: [],
            leftCheckedKeys: [],
            rightCheckedKeys: [],
            leftKeywords: '',
            rightKeywords: '',
            leftFilteredData: rawData,
            rightFilteredData: [],
        } as Props;
    }

    filterData(data: DataItem[], keywords: string): DataItem[] {
        if (!keywords) return data;
        const lowerKeywords = keywords.toLowerCase();
        return data.filter((item: DataItem) => 
            item.name.toLowerCase().includes(lowerKeywords) ||
            item.ip.includes(keywords) ||
            item.status.includes(keywords)
        );
    }

    @bind
    onLeftKeywordsChange(v: string | undefined) {
        const keywords = v || '';
        this.set('leftKeywords', keywords);
        const data = this.filterData(this.get('leftData'), keywords);
        this.set('leftFilteredData', data);
    }

    @bind
    onRightKeywordsChange(v: string | undefined) {
        const keywords = v || '';
        this.set('rightKeywords', keywords);
        const data = this.filterData(this.get('rightData'), keywords);
        this.set('rightFilteredData', data);
    }

    @bind
    onLeftCheckedKeysChange(keys: number[] | undefined) {
        this.set('leftCheckedKeys', keys || []);
    }

    @bind
    onRightCheckedKeysChange(keys: number[] | undefined) {
        this.set('rightCheckedKeys', keys || []);
    }

    @bind
    enableAdd() {
        const keys = this.get('leftCheckedKeys');
        return keys && keys.length > 0;
    }

    @bind
    enableRemove() {
        const keys = this.get('rightCheckedKeys');
        return keys && keys.length > 0;
    }

    @bind
    onAdd() {
        const leftCheckedKeys = this.get('leftCheckedKeys');
        const leftData = this.get('leftData');
        const rightData = this.get('rightData');
        
        const selectedItems = leftData.filter((item: DataItem) => leftCheckedKeys.includes(item.id));
        const newLeftData = leftData.filter((item: DataItem) => !leftCheckedKeys.includes(item.id));
        const newRightData = [...rightData, ...selectedItems];
        
        this.set({
            leftData: newLeftData,
            rightData: newRightData,
            leftCheckedKeys: [],
        });

        const leftFiltered = this.filterData(newLeftData, this.get('leftKeywords'));
        const rightFiltered = this.filterData(newRightData, this.get('rightKeywords'));
        this.set('leftFilteredData', leftFiltered);
        this.set('rightFilteredData', rightFiltered);
    }

    @bind
    onRemove() {
        const rightCheckedKeys = this.get('rightCheckedKeys');
        const allData = this.get('allData');
        const rightData = this.get('rightData');
        
        const newRightData = rightData.filter((item: DataItem) => !rightCheckedKeys.includes(item.id));
        const rightDataIds = new Set(newRightData.map((item: DataItem) => item.id));
        const newLeftData = allData.filter((item: DataItem) => !rightDataIds.has(item.id));
        
        this.set({
            leftData: newLeftData,
            rightData: newRightData,
            rightCheckedKeys: [],
        });

        const leftFiltered = this.filterData(newLeftData, this.get('leftKeywords'));
        const rightFiltered = this.filterData(newRightData, this.get('rightKeywords'));
        this.set('leftFilteredData', leftFiltered);
        this.set('rightFilteredData', rightFiltered);
    }
}